import React, { useState } from 'react';
import '../../assets/styles/index.css';
import logo from '../../assets/images/logo.jpg';
import api from '../../services/api';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Real API Call
      const response = await api.post('/auth/login', { email, password });
      const data = response.data;

      localStorage.setItem('auth_token', data.access_token);
      
      // Map backend user to frontend user object
      const userObj = {
        user_id: data.user.user_id,
        name: `${data.user.first_name} ${data.user.last_name}`,
        roles: data.user.roles.map(r => r.toLowerCase()),
        email: data.user.email,
        username: data.user.username,
        permissions: data.user.permissions
      };
      
      localStorage.setItem('user', JSON.stringify(userObj));
      onLogin(userObj);
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      height: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'radial-gradient(circle at top right, #1e293b, #0f172a)' 
    }}>
      <div className="card glass animate-fade-in" style={{ width: '100%', maxWidth: '440px', padding: '48px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img src={logo} alt="MSU Logo" style={{ width: '100px', marginBottom: '16px' }} />
          <h2 className="gradient-text" style={{ fontSize: '32px', marginBottom: '8px' }}>MSU RiskX</h2>
          <p style={{ color: 'var(--text-secondary)' }}>Please sign in to continue</p>
        </div>
        
        {error && (
          <div style={{ padding: '12px', background: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', borderRadius: '8px', marginBottom: '20px', fontSize: '14px', textAlign: 'center' }}>
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500 }}>Email Address</label>
            <input 
              type="email" 
              placeholder="name@staff.msu.ac.zw" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required 
            />
          </div>
          <div className="input-group">
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500 }}>Password</label>
            <input 
              type="password" 
              placeholder="••••••••" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required 
            />
          </div>
          
          
          <button type="submit" className="btn btn-primary" style={{ width: '100%', height: '48px' }} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        
      </div>
    </div>
  );
};

export default Login;
